export default __webpack_public_path__ + "static/media/barcodeScanner.c15ad609.png";